export const frLocale = {
    locale: 'fr',
    messages: {
        'toast.error.defaultMessage': "Quelque chose ne s'est pas passé comme prévu, merci de réessayer",

        'list.search.placeholder': 'Rechercher',
        'list.results.none': 'Aucun résultat trouvé',
        'list.results.one': '1 résultat trouvé',
        'list.results.other': '{total_count} résultats trouvés',

        // CONFIRM DIALOG
        'dialog.confirm.button.confirm': 'Confirmer',
        'dialog.confirm.button.cancel': 'Annuler',

        // CATEGORIES
        'category.unknown': 'Catégorie inconnue',

        // PDFPICKER
        'pdf.picker.pick.hint': 'Sélectionnez un fichier PDF',
        'pdf.picker.button.open': 'Parcourir',
        'pdf.picker.button.edit': 'Modifier',

        // Loading page
        'app.load.error.message': `L'application a rencontré une erreur pendant son chargement.
        Cliquez sur le bouton ci-dessous pour réessayer`,
        'app.load.error.button': 'Réessayer',

        // NAVIGATION
        'navigation.user.disconnect.dialog.title': 'Confirmation déconnexion',
        'navigation.user.disconnect.dialog.message': 'Voulez-vous vraiment vous déconnecter ?',

        // DATE PICKER

        'date.picker.actions.label.ok': 'OK',
        'date.picker.actions.label.cancel': 'ANNULER',
        'date.picker.actions.label.clear': 'EFFACER',
        'date.picker.actions.label.today': "AUJOURD'HUI",
        'date.picker.date.invalid.min': 'La date ne peut pas être avant la date minimale',
        'date.picker.date.invalid.max': 'La date ne peut pas être après la date maximale',
        'date.picker.date.invalid.date': 'Cette date est invalide',

        'dates.from': 'Du',
        'dates.to': 'au',
        'dates.the': 'Le',

        'add.to.clipboard.title': 'Copié : {text} !',
        'add.to.clipboard.title.default': 'Copié !',
    },
};
